<template>
    <div :class="$style.container">
        <div :class="$style.header">
            <Typography
                type="label"
                size="m"
                :responsive="false"
                :class="$style.title"
            >
                {{ tr('suggestedGamePopup.title') }}
            </Typography>
            <GhostIconButton
                icon="close"
                size="s"
                color="white-60"
                interfaceTarget="switch-game-close"
                :class="$style.close_button_override"
                @click="emit('close')"
            />
        </div>
        <div :class="$style.content">
            <div
                :class="$style.cover_wrap"
                @click="emit('play')"
            >
                <img
                    :src="props.game.preview"
                    :alt="props.game.title"
                    :class="$style.cover"
                />
            </div>
            <div :class="$style.text">
                <Typography
                    type="label"
                    size="xs"
                    :responsive="false"
                    :class="$style.game_title"
                    @click="emit('play')"
                >
                    {{ props.game.title }}
                </Typography>
                <Stars
                    :rating="props.game.rating"
                    :showLabel="false"
                    :class="$style.stars_small_override"
                />
            </div>
            <Button
                width="full"
                color="purple-400"
                :label="tr('gameContainer.play')"
                interfaceTarget="suggested-game-play"
                @click="emit('play')"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'

import Button from '@/components_new/Buttons/Button.vue'
import GhostIconButton from '@/components_new/Buttons/GhostIconButton.vue'
import Stars from '@/components_new/Stars.vue'
import Typography from '@/components_new/Typography.vue'
import { useTr } from '@/composables/use-tr'
import { useLoggerStore } from '@/store/logger'
import { APIGameMostRatedType } from '@/types'

const props = defineProps<{
    game: APIGameMostRatedType
}>()

const emit = defineEmits<{
    close: []
    play: []
}>()

const tr = useTr()
const loggerStore = useLoggerStore()

onMounted(() => {
    loggerStore.logEvent({
        event: 'custom_event',
        eventName: 'show_suggested_game_popup',
    })
})
</script>

<style module>
.container {
    backdrop-filter: blur(4px);
    background: rgba(42, 41, 53, 0.8);
    border: 1px solid rgba(255, 255, 255, 0.04);
    border-radius: var(--radius-24);
    display: flex;
    flex-direction: column;
    padding-bottom: 8px;
    color: white;
    width: 260px;
}

@media (width < 660px) {
    .container {
        width: 180px;
    }
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 44px;
    padding-left: 12px;
}

.title {
    flex: 1;
}

.close_button_override {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
}

.content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 0 8px;
}

.cover_wrap {
    aspect-ratio: 374 / 210;
    border-radius: var(--radius-16);
    overflow: hidden;
    width: 100%;
    cursor: pointer;
}

.cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.text {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.game_title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}

.stars_small_override {
    transform: scale(0.7);
    transform-origin: left top;
    margin-bottom: -10px;
}
</style>
